<template>
  <div class="wrap">
    <div class="inner">
      <div class="content">
        <h2>{{ item.name }}</h2>
        <div class="imgbox">
          <img :src="item.url" alt="">
        </div>
        <p>{{ item.title }}</p>
        <p>{{ item.title1 }}</p>
        <p>{{ item.title2 }}</p>
        <p>{{ item.title3 }}</p>
        <p>{{ item.title4 }}</p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Detail',
  props: ['item'],
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.inner {
  width: 1200px;
  min-height: 800px;
  margin-top: 90px;
  margin-bottom: 20px;
  background-color: #f2f2f2;
  padding: 10px;
  .content{
    font-size: 18px;
    color: #6a6a6a;
    min-height: 800px;
    background-color: #ffffff;
    padding: 10px;
    h2{
      color: #000000;
      font-size: 20px;
      font-weight: 700;
      text-align: center;
    }
    p{
      font-size: 18px;
      line-height: 36px;
    }
    .imgbox{
      margin: 20px 0px;
      text-align: center;
      img{
        width: 500px;
      }
    }
  }
}
</style>
